import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSparkle = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 12 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M6 0.49353L7.875 4.61853L12 6.49353L7.875 8.36853L6 12.4935L4.125 8.36853L0 6.49353L4.125 4.61853L6 0.49353ZM6 4.11603L5.25 5.74353L3.6225 6.49353L5.25 7.24353L6 8.87103L6.75 7.24353L8.3775 6.49353L6.75 5.74353L6 4.11603Z"
	})
});
export default SvgSparkle;
